<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate>

    <app-list-view [title]="t('common.labels.documents')" [messages]="messages" [loading]="loading">

      <div buttons>
        <button withRight="admin.document.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
        <button [withRight]="'admin.document.create'" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-success p-ml-2 p-mb-2 autofocus"></button>
      </div>

      <div table>
        <p-table
          [value]="documents"
          [paginator]="true"
          [rows]="20"
          stateStorage="local"
          stateKey="documents-list"
          [rowsPerPageOptions]="rowsPerPage"
          [showCurrentPageReport]="true"
          [currentPageReportTemplate]="t('common.labels.current_page_report')"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 50%">{{ t('common.labels.file') }}</th>
                    <th>{{ t('common.labels.last_update') }}</th>
                    <th>{{ t('common.labels.filesize') }}</th>
                    <th style="width: 150px;"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-document>
                <tr *ngIf="inEdit !== true || editDocument !== document">
                  <td><p>{{ document.public_name }}</p></td>
                  <td><p>{{ document.updated_at | amLocal | amDateFormat: 'DD.MM.YYYY - HH:mm' }}</p></td>
                  <td><p>{{ document.filesize }}</p></td>
                  <td style="vertical-align: top; text-align: right">
                    <span *ngIf="inEdit !== true">
                      <button [withRight]="'admin.document.download'"pButton (click)="onDownload(document)" type="button" icon="pi pi-download" class="p-ml-2"></button>
                      <button [withRight]="'admin.document.edit'" *ngIf="document.updateable" pButton (click)="onEdit(document)" type="button" icon="pi pi-pencil" class="p-button-outlined p-ml-2"></button>
                      <button [withRight]="'admin.document.delete'" *ngIf="document.deletable" pButton (click)="onStartDelete(document)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2"></button>
                    </span>
                  </td>
                </tr>
                <tr *ngIf="inEdit === true && editDocument === document">
                  <ng-template [ngTemplateOutlet]="tForm"></ng-template>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td class="no-data" colspan="4">{{ t('common.texts.no_files') }}</td>
              </tr>
            </ng-template>
        </p-table>
      </div>

    </app-list-view>

  </form>

  <ng-template #tForm>
    <td colspan="3" style="vertical-align: top;">
      <app-form-control [cid]="'filename'" [control]="form.get('filename')" [type]="'input'" [label]="''" [basevalue]="editDocument?.public_name"></app-form-control>
    </td>
    <td style="vertical-align: top; text-align: right">
      <app-form-buttons [submitting]="submitting" [icons]="false" (cancelled)="onCancel()"></app-form-buttons>
    </td>
  </ng-template>

  <app-file-handling #filehandler (filesUpload)="onFilesUpload($event)" (fileDelete)="onDelete($event)"></app-file-handling>

</ng-container>
